import React from "react";
import { Modal } from "react-bootstrap";
import AppStoreGuidance from "./AppStoreGuidance";
import "./manageSubscriptionModal.css";

/**
 * Subscription management surface for App-Store-billed users.
 *
 * variant "app_store": App Store guidance only (the user has no live
 * Stripe subscription — the Stripe billing portal cannot serve them).
 * variant "dual": the user holds live subscriptions with BOTH providers;
 * offer the Stripe portal entry alongside the App Store guidance.
 * `onManageWebBilling` is only used by the "dual" variant and is expected
 * to start the existing customer-portal flow (API call stays in the caller).
 */
export default function ManageSubscriptionModal({
  open,
  onClose,
  variant = "app_store",
  onManageWebBilling,
}) {
  return (
    <Modal
      show={open}
      onHide={onClose}
      centered
      className="manage-subscription-modal-wrapper"
    >
      <Modal.Body className="p-0">
        <div className="manage-subscription-modal">
          <div className="manage-subscription-modal-header">
            <span>Manage Your Subscription</span>
            <button
              className="manage-subscription-modal-close"
              onClick={onClose}
              aria-label="Close"
            >
              &times;
            </button>
          </div>
          <hr className="manage-subscription-modal-divider" />
          <div className="manage-subscription-modal-body">
            {variant === "dual" && (
              <div className="manage-subscription-modal-web">
                <p className="manage-subscription-modal-web-text">
                  Your web subscription is billed by Stripe.
                </p>
                <button
                  className="manage-subscription-modal-web-cta"
                  onClick={onManageWebBilling}
                >
                  Manage web billing
                </button>
                <hr className="manage-subscription-modal-divider" />
              </div>
            )}
            <AppStoreGuidance />
          </div>
          <hr className="manage-subscription-modal-divider" />
          <div className="manage-subscription-modal-footer">
            <button className="manage-subscription-modal-cta" onClick={onClose}>
              Got it
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
